export default "__VITE_PUBLIC_ASSET__e2c5f5ab__"